(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bb-home-nav"] && !Shopify.designMode) return;
  try {
    
function bbBindCategoryImageFallbacks() {
  document.querySelectorAll('.bb-category-photo[data-category-fallback]').forEach(function(image) {
    if (image.dataset.fallbackBound) return;
    image.dataset.fallbackBound = 'true';
    function recover() {
      var fallback = image.dataset.categoryFallback;
      if (!fallback || image.dataset.fallbackUsed) return;
      image.dataset.fallbackUsed = 'true';
      image.removeAttribute('srcset');
      image.src = fallback;
    }
    image.addEventListener('error', recover);
    if (image.complete && image.naturalWidth === 0) recover();
  });
}
bbBindCategoryImageFallbacks();
document.addEventListener('shopify:section:load', bbBindCategoryImageFallbacks);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
class StickyHeader extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.header = document.querySelector('.section-header');
    this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
    this.headerBounds = {};
    this.setHeaderHeight();
    this.headerHeightChange = this.setHeaderHeight.bind(this);
    this.headerBreakpoint = window.matchMedia('(max-width: 992px)');
    this.headerBreakpoint.addEventListener('change', this.headerHeightChange);
    this.headerResizeObserver = new ResizeObserver(this.headerHeightChange);
    this.headerResizeObserver.observe(this.header);
    if (this.headerIsAlwaysSticky) {
      this.header.classList.add('shopify-section-header-sticky');
    };
    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.predictiveSearch = this.querySelector('predictive-search');
    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => this.preventReveal = true;
    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, false);
    this.createObserver();
  }
  setHeaderHeight() {
    const height = this.header.offsetHeight;
    document.documentElement.style.setProperty('--header-height', `${height}px`);
    if (Number.isFinite(this.headerBounds.top)) {
      this.headerBounds.bottom = this.headerBounds.top + height;
    }
  }
  disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
    this.headerBreakpoint.removeEventListener('change', this.headerHeightChange);
    this.headerResizeObserver.disconnect();
  }
  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });
    observer.observe(this.header);
  }
  pinForCartDrawer() {
    if (this.cartDrawerPinned) return;
    this.cartDrawerPinned = true;
    this._cartDrawerHadSticky = this.header.classList.contains('shopify-section-header-sticky');
    this._cartDrawerHadHidden = this.header.classList.contains('shopify-section-header-hidden');
    this._cartDrawerHadScrolled = this.header.classList.contains('scrolled-past-header');
    this._cartDrawerHadAnimate = this.header.classList.contains('animate');
    this._cartDrawerPreventReveal = this.preventReveal;
    this.preventReveal = true;
    this.header.classList.add('shopify-section-header-sticky', 'cart-drawer-pinned');
    this.header.classList.remove('shopify-section-header-hidden', 'animate');
    this.setHeaderHeight();
  }
  syncHeaderHeightForCartFly() {
    if (this.header) this.setHeaderHeight();
  }
  unpinForCartDrawer() {
    if (!this.cartDrawerPinned) return;
    this.cartDrawerPinned = false;
    this.preventReveal = this._cartDrawerPreventReveal;
    this.header.classList.remove('cart-drawer-pinned');
  }
  onScroll() {
    if (this.cartDrawerPinned) return;
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
    if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.header.classList.add('scrolled-past-header');
      if (this.preventHide) return;
      requestAnimationFrame(this.hide.bind(this));
    } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.header.classList.add('scrolled-past-header');
      if (!this.preventReveal) {
        requestAnimationFrame(this.reveal.bind(this));
      } else {
        window.clearTimeout(this.isScrolling);
        this.isScrolling = setTimeout(() => {
          this.preventReveal = false;
        }, 66);
        requestAnimationFrame(this.hide.bind(this));
      }
    } else if (scrollTop <= this.headerBounds.top) {
      this.header.classList.remove('scrolled-past-header');
      requestAnimationFrame(this.reset.bind(this));
    }
    this.currentScrollTop = scrollTop;
  }
  hide() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    this.closeMenuDisclosure();
    this.closeSearchModal();
  }
  reveal() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-sticky', 'animate');
    this.header.classList.remove('shopify-section-header-hidden');
  }
  reset() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
  }
  closeMenuDisclosure() {
    this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
    this.disclosures.forEach(disclosure => disclosure.close());
  }
  closeSearchModal() {
    this.searchModal = this.searchModal || this.header.querySelector('details-modal');
  }
}
customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
